import { defineMessages } from 'react-intl';

export default defineMessages({
    header: {
        id: 'app.components.CourseCreator.header',
        defaultMessage: 'Course Manager'
    },
    back: {
        id: 'app.components.CourseCreator.back',
        defaultMessage: 'Back'
    },
    save: {
        id: 'app.components.CourseCreator.save',
        defaultMessage: 'Save as draft'
    },
    publish: {
        id: 'app.components.CourseCreator.publish',
        defaultMessage: 'Publish'
    },
    country: {
        id: 'app.components.CourseCreator.country',
        defaultMessage: 'Country'
    },
    state: {
        id: 'app.components.CourseCreator.state',
        defaultMessage: 'State'
    },
    yearLevel: {
        id: 'app.components.CourseCreator.yearLevel',
        defaultMessage: 'Year'
    },
    curriculum: {
        id: 'app.components.CourseCreator.curriculum',
        defaultMessage: 'Curriculum'
    },
    spine: {
        id: 'app.components.CourseCreator.spine',
        defaultMessage: 'Spine items'
    },
    topics: {
        id: 'app.components.CourseCreator.topics',
        defaultMessage: 'Topics'
    },
    newTopic: {
        id: 'app.components.CourseCreator.newTopic',
        defaultMessage: 'Create New Topic'
    },
    expand: {
        id: 'app.components.CourseCreator.expand',
        defaultMessage: 'Expand'
    },
    collapse: {
        id: 'app.components.CourseCreator.collapse',
        defaultMessage: 'Collapse'
    },
    add: {
        id: 'app.components.CourseCreator.add',
        defaultMessage: 'Add'
    },
    subTopic: {
        id: 'app.components.CourseCreator.subTopic',
        defaultMessage: 'Create Sub Topic'
    },
    requiredFields: {
        id: 'app.components.CourseCreator.requiredFields',
        defaultMessage: 'Required Fields'
    },
    editTopic: {
        id: 'app.components.CourseCreator.editTopic',
        defaultMessage: 'Edit Topic Details'
    },
    topicName: {
        id: 'app.components.CourseCreator.topicName',
        defaultMessage: 'Topic Name'
    },
    topicType: {
        id: 'app.components.CourseCreator.topicType',
        defaultMessage: 'Topic Type'
    },
    strandFilter: {
        id: 'app.components.CourseCreator.strandFilter',
        defaultMessage: 'Strand Filter'
    },
    subStrandFilter: {
        id: 'app.components.CourseCreator.subStrandFilter',
        defaultMessage: 'Sub-Strand Filter'
    },
    curriculumLevelLink: {
        id: 'app.components.CourseCreator.curriculumLevelLink',
        defaultMessage: 'Curriculum Level Link'
    },
    externalKey: {
        id: 'app.components.CourseCreator.externalKey',
        defaultMessage: 'External Key'
    },
    description: {
        id: 'app.components.CourseCreator.description',
        defaultMessage: 'Description'
    },
    update: {
        id: 'app.components.CourseCreator.description',
        defaultMessage: 'Update'
    },
    delete: {
        id: 'app.components.CourseCreator.delete',
        defaultMessage: 'Delete'
    },
    detailsNotSaved: {
        id: 'app.components.CourseCreator.detailsNotSaved',
        defaultMessage: 'Topic details have NOT been saved'
    },
    detailsSaved: {
        id: 'app.components.CourseCreator.detailsSaved',
        defaultMessage: 'Topic has been updated'
    },
    curriculumLinkPlaceholder: {
        id: 'app.containers.CourseCreator.curriculumLinkPlacehoderMessage',
        defaultMessage: 'Search the Curriculum for link node'
    },
    keepTopicNameLessThan: {
        id: 'app.containers.CourseCreator.keepTopicNameLessThan',
        defaultMessage: 'Please keep topic name less than'
    },
    characters: {
        id: 'app.containers.CourseCreator.characters',
        defaultMessage: 'characters'
    },
    spinesUnderSteps: {
        id: 'app.containers.CourseCreator.spinesUnderSteps',
        defaultMessage: 'Spine items can only be added to Steps'
    },
    spinesUnderDescriptor: {
        id: 'app.containers.CourseCreator.spinesUnderDescriptor',
        defaultMessage: 'Spine items can only be added to Descriptors'
    },
    selectProduct: {
        id: 'app.containers.CourseCreator.selectProduct',
        defaultMessage: 'Select product'
    },
    productSelectorHeading: {
        id: 'app.containers.CourseCreator.productSelectorHeading',
        defaultMessage: 'Product:'
    },
    emptySteps: {
        id: 'app.containers.CourseCreator.emptySteps',
        defaultMessage: 'Steps cannot be empty'
    },
    emptyCurriculumLink: {
        id: 'app.containers.CourseCreator.emptyCurriculumLink',
        defaultMessage: 'Spine must belong to the curriculum link specified for this course standard'
    },
    noSpineNode: {
        id: 'app.containers.CourseCreator.noSpineNode',
        defaultMessage: 'Please add spine nodes to course'
    }
});



// WEBPACK FOOTER //
// ./app/components/course-creator/messages.js